import { Button } from "@mui/material";

const IndicationTypeButton = ({
  type,
  Icon,
  onClick,
}: {
  type: string;
  Icon: any;
  onClick: () => void;
}) => {
  return (
    <Button
      id="indicationTypeButton"
      color="info"
      onClick={onClick}
      variant="contained"
      style={{
        display: "flex",
        justifyContent: "center",
        gap: 10,
        width: 300,
        padding: "10px 0px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 44,
            width: 44,
            backgroundColor: "rgb(224, 235, 248)",
            borderRadius: 25,
          }}
        >
          {Icon}
        </div>
      </div>

      <div
        style={{
          textAlign: "start",
          lineHeight: 1.4,
        }}
      >
        <div style={{ fontWeight: 600, fontSize: 14, color: "black" }}>
          {`${type} Indication`}
        </div>
        <div
          style={{
            fontWeight: 400,
            fontSize: 14,
            color: "rgb(152,152,152)",
          }}
        >
          {`Add a ${type} Indication`}
        </div>
      </div>
    </Button>
  );
};

export default IndicationTypeButton;
